// deno-fmt-ignore-file
export function ApplyMapping(mapping, value) {
    return mapping(value);
}
